import { h } from "preact";
import './sign-address-styles.scss'
import { t } from '../../../_i18n'

export default function SignAddress ({ className }) {
  return (
    <div className={`fct-sign-address ${className || ''}`}>
      <div className='fct-sign-address__title'>ILERNA ONLINE S.L.</div>
      <div>{t('A/A: Departamento de Prácticas')}</div>
      <div>{t('C/Térmens, 2-4 (Pol. Activa Park)')}</div>
      <div>{t('25190 Lleida')}</div>
    </div>
  )
}
